import * as React from 'react';
import { View, StyleSheet } from 'react-native';
import Text from 'design-system/Text';
import Modal from 'utils/packages/Modal';
import { rem, Spacer } from 'design-system';
import ToolTipContent from 'design-system/ToolTipContent';
const FSCSCompensationInfo = () => {
    const handleLearnMore = React.useCallback(() => {
        Modal.show(<ToolTipContent subtitle={<View>
            <Text TextThin-14 Secondary centered>
              Eligible investments may be protected by the Financial Services Compensation Scheme up to £85,000 per
              person, per firm if the firm fails and your assets cannot be returned.
            </Text>
            <Spacer h={10}/>
            <Text TextThin-14 Secondary centered>
              FSCS protection does not cover losses from investment performance, or if you get back less than you
              originally invested.
            </Text>
          </View>} onPress={() => {
                Modal.hide(undefined, { top: true });
            }} btnText={'Okay'}/>, {
            title: 'FSCS protection up to £85,000',
            top: true,
        });
    }, []);
    return (<View style={styles.container}>
      <Text TextThin-14 Secondary centered>
        Eligible investments may be protected by the FSCS up to{' '}
        <Text NumbersThin-14 Secondary>
          £85,000
        </Text>{' '}
        per person, per firm. Investment performance is not covered.{' '}
        <Text Text-14 Primary suppressHighlighting onPress={handleLearnMore}>
          Learn{`\xa0`}more
        </Text>
      </Text>
    </View>);
};
export default React.memo(FSCSCompensationInfo);
const styles = StyleSheet.create({
    container: {
        paddingHorizontal: rem(16),
        paddingBottom: rem(24),
        paddingTop: rem(8),
    },
});
